// libraries
import { dealerSelectors } from '@makemydeal/dr-shared-store';

// interfaces/types
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { UsabilityContext } from './usabilityTelemetry';

// selectors
import * as offerReduxSelectors from '../selectors/offerRedux';
import * as vehicleSelectors from '../selectors/vehicleSelectors';

/**
 * The deal-identifying context every MV usability event carries.
 *
 * Built here rather than inline at each call site so that adding a field — or fixing one of these five
 * selectors — is one edit instead of one per middleware. `paymentRaceTelemetryMiddleware` and
 * `paymentSequenceMiddleware` had byte-identical copies of this object.
 *
 * Deliberately NOT in `usabilityTelemetry.ts` alongside `UsabilityContext`: that module is imported by
 * components and mocked wholesale by a number of specs, so pulling the selector graph into it would widen
 * both the bundle and the blast radius of those mocks. The type import here is erased at compile time.
 */
export const buildUsabilityContext = (state: StateTree): UsabilityContext => ({
    sessionId: offerReduxSelectors.getSessionId(state),
    dealXgId: offerReduxSelectors.getDealXgId(state),
    dealType: offerReduxSelectors.getCurrentOfferType(state),
    mmdDealerId: dealerSelectors.getDealerId(state),
    vin: vehicleSelectors.getVehicleVin(state)
});
